
import axios from "axios";
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    lista: [],
    dt1: moment().format('YYYY-MM-DD'),
    dt2: moment().format('YYYY-MM-DD'),
    responsavelId: null,
    registroId: null,
    registroSelecionadoId: null,
  },
  getters: {
    LISTA: state => {
      return state.lista
    },
    DT1: state => {
      return state.dt1
    },
    DT2: state => {
      return state.dt2
    },
    RESPONSAVEL_ID: state => {
      return state.responsavelId
    },
    REGISTRO_ID: state => {
      return state.registroId
    },
    REGISTRO_SELECIONADO_ID: state => {
      return state.registroSelecionadoId
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => {
      state.lista = payload
    },
    SET_DT1: (state, payload) => {
      state.dt1 = payload
    },
    SET_DT2: (state, payload) => {
      state.dt2 = payload
    },
    SET_RESPONSAVEL_ID: (state, payload) => {
      state.responsavelId = payload
    },
    SET_LIMPAR: (state, payload) => {
      state.lista = []
      state.dt1 = moment().format('YYYY-MM-DD')
      state.dt2 = moment().format('YYYY-MM-DD')
      state.responsavelId = null
      // NÃO limpar registroSelecionadoId aqui - mantém linha selecionada
    },
    SET_REGISTRO_ID: (state, payload) => {
      state.registroId = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        let responsavelId = (getters.RESPONSAVEL_ID !== null ? getters.RESPONSAVEL_ID : '')
        let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
        let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
        let uri = `/api/protected/ordemexpedicao/pesquisar?dt1=${dt1}` +
          `&dt2=${dt2}`
        if (responsavelId) {
          uri += `&responsavelId=${responsavelId}`
        }
        axios
          .get(uri)
          .then(({ data, status }) => {
            commit("SET_LISTA", data);
            if (status === 200 || status === 201) {
              resolve({ data, status });
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/ordem-expedicao-store.js